<template>
  <div class="w-full flex flex-col justify-center items-center contact-us-main-container">
    <validation-observer
      class="w-full max-w-[1216px]"
      tag="form"
      ref="validation"
      v-slot="{ invalid }"
      @submit.prevent="handleSubmit"
    >
      <div class="flex flex-col 1170-bp:flex-row gap-2 1170-bp:gap-5">
        <div class="w-full field">
          <label class="contact-us-label">First Name <span>*</span></label>
          <div class="control mt-1.5">
            <validated-input v-model="lead.firstName" name="First name" page="contact-us" rules="required" />
          </div>
        </div>
        <div class="w-full field">
          <label class="contact-us-label">Last Name <span>*</span></label>
          <div class="control mt-1.5">
            <validated-input v-model="lead.lastName" name="Last name" page="contact-us" rules="required" />
          </div>
        </div>
      </div>

      <div class="flex flex-col 1170-bp:flex-row gap-2 1170-bp:gap-5">
        <div class="w-full field hide-below-1441">
          <label class="contact-us-label">Email <span>*</span></label>
          <div class="control mt-1.5">
            <validated-input v-model="lead.email" name="Email" page="contact-us" rules="required|email" />
          </div>
        </div>
        <div class="w-full field phone-field">
          <label class="contact-us-label">Phone <span>*</span></label>
          <div class="control mt-1.5">
            <validated-input
              v-model="lead.phone"
              name="Phone number"
              page="contact-us"
              :rules="{ required: true, regex: /^\+?[0-9()-]*$/ }"
            />
          </div>
        </div>
        <div class="w-full field hide-above-1440">
          <label class="contact-us-label">Email <span>*</span></label>
          <div class="control mt-1.5">
            <validated-input v-model="lead.email" name="Email" page="contact-us" rules="required|email" />
          </div>
        </div>
      </div>

      <div class="flex flex-col 1170-bp:flex-row gap-2 1170-bp:gap-5">
        <div class="w-full field hide-below-1441">
          <label class="contact-us-label">Zip Code <span>*</span></label>
          <div class="mt-1.5">
            <validated-input
              v-model="lead.zipcode"
              name="Delivery zip"
              page="contact-us"
              icon="zipCode"
              :rules="{ required: true, regex: /^\d{5}$|^\d{5}-\d{4}$/ }"
            />
          </div>
        </div>
        <div class="w-full field hide-below-1441 toggle-options">
          <label class="contact-us-label">Rental or Purchase</label>
          <div class="control mt-1.5">
            <div class="button-group">
              <button
                type="button"
                :class="['option-button', { 'selected-button': lead.data.purchaseType === 'Sale' }]"
                @click="lead.data.purchaseType = 'Sale'"
              >
                Buy
              </button>
              <button
                type="button"
                :class="['option-button', { 'selected-button': lead.data.purchaseType === 'Rental' }]"
                @click="lead.data.purchaseType = 'Rental'"
              >
                Rent
              </button>
              <button
                type="button"
                :class="['option-button', { 'selected-button': lead.data.purchaseType === 'Not Sure' }]"
                @click="lead.data.purchaseType = 'Not Sure'"
              >
                Don't know
              </button>
            </div>
          </div>
        </div>
        <div class="w-full field hide-above-1440 mt-4 1170-bp:mt-0">
          <label class="contact-us-label">Zip Code <span>*</span></label>
          <div class="mt-1.5">
            <validated-input
              v-model="lead.zipcode"
              name="Delivery zip"
              page="contact-us"
              icon="zipCode"
              :rules="{ required: true, regex: /^\d{5}$|^\d{5}-\d{4}$/ }"
            />
          </div>
        </div>
        <div class="w-full field mb-5 hide-above-1440">
          <label class="contact-us-label">Rental or Purchase</label>
          <div class="control mt-1.5">
            <div class="button-group">
              <button
                type="button"
                :class="['option-button', { 'selected-button': lead.data.purchaseType === 'Sale' }]"
                @click="lead.data.purchaseType = 'Sale'"
              >
                Buy
              </button>
              <button
                type="button"
                :class="['option-button', { 'selected-button': lead.data.purchaseType === 'Rental' }]"
                @click="lead.data.purchaseType = 'Rental'"
              >
                Rent
              </button>
              <button
                type="button"
                :class="['option-button', { 'selected-button': lead.data.purchaseType === 'Not Sure' }]"
                @click="lead.data.purchaseType = 'Not Sure'"
              >
                Don't know
              </button>
            </div>
          </div>
        </div>
      </div>

      <div>
        <div class="flex flex-col 1170-bp:flex-row gap-2 1170-bp:gap-5">
          <div class="w-full field">
            <label class="contact-us-label">Company or Organization</label>
            <div class="control mt-1.5">
              <input v-model="lead.company" type="text" class="input contact-us-input" />
            </div>
          </div>
          <div class="w-full field mb-5 1170-bp:mb-0">
            <label class="contact-us-label">Quantity</label>
            <div class="control mt-1.5">
              <validated-input v-model="lead.data.quantity" name="Quantity" page="contact-us" rules="integer|min_value:0" />
            </div>
          </div>
        </div>
        <div class="field">
          <label class="contact-us-label">Message (Optional)</label>
          <div class="control mt-1.5">
            <textarea
              v-model="lead.notes"
              placeholder="Type your message..."
              class="textarea contact-us-input h-[150px]"
              title="Notes"
            ></textarea>
          </div>
        </div>
        <div class="flex 1440-bp:flex-row flex-col 1440-bp:justify-between 1440-bp:gap-0 gap-2 mb-0 mt-4">
          <label class="checkbox flex items-center">
            <input type="checkbox" class="mr-2 filter-checkbox" v-model="lead.smsConsent">
            <b class="contact-us-consent-text">I consent to receive SMS text messages from this business.</b>
          </label>
          <div class="flex justify-end">
            <button
              :disabled="invalid || loading > 0"
              :class="['w-[155px] h-[44px] border border-[#3565FC] rounded-full bg-[#3565FC] flex justify-center items-center', { 'cursor-not-allowed': invalid || loading > 0 }]"
              type="submit"
            >
              <p class="send-message-btn-txt">Send Message</p>
            </button>
          </div>
        </div>
      </div>
    </validation-observer>
  </div>
</template>

<script>
import leadForm from 'shared/mixins/lead-form'
export default {
  mixins: [leadForm],
  created() {
    this.lead.data.purchaseType = 'Sale'
  }
}
</script>

<style scoped>
.contact-us-label {
  color: #334155;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: -0.0125em;
  text-align: left;
}
.contact-us-label span {
  color: #dc2626;
}
.contact-us-input {
  background-color: #ffffff !important;
  border: 1px solid #ede9e3 !important;
  border-radius: 10px !important;
}
.contact-us-consent-text {
  font-size: 14px;
  font-weight: 400;
  line-height: 21px;
  color: #334155;
}
.send-message-btn-txt {
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: -0.04em;
  color: #fff;
}
.button-group {
  height: 40px;
  display: flex;
  background-color: #ede9e3;
  border-radius: 10px;
  padding: 2px;
}
.option-button {
  flex: 1;
  padding: 10px 0;
  border: 1px solid #ede9e3;
  border-radius: 10px;
  background-color: #ede9e3;
  color: #334155;
  font-size: 12px;
  font-weight: 500;
  line-height: 12px;
  text-align: center;
  cursor: pointer;
}
.option-button:hover {
  background-color: #f0f4f8;
}
.selected-button {
  background-color: #ffffff;
  color: #000000;
  border-color: #ffffff;
}
.phone-field {
  margin-top: 0px;

}
@media (max-width: 1440px) {
  .hide-below-1441 {
    display: none !important;
  }
}
@media (min-width: 1441px) {
  .hide-above-1440 {
    display: none !important;
  }
}
@media (max-width: 1170px) {
  .contact-us-main-container {
    padding: 0 20px 20px;
  }
  .phone-field {
    margin-top: 1rem;
  }
}
</style>
